import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useMediaQuery, useTheme } from '@material-ui/core'
import ProductListingWidget from '../../widgets/ProductListingWidget/ProductListingWidget'
import { useDMEStore } from '../../store'
import { STORE_PATH } from '../../constants'
import { UI } from '../../../global'
import CustomerInformationView from '../CustomerInformationView'
import HomeView from '../HomeView'
import PLPBannerWidget from '../../widgets/PLPBannerWidget/PLPBannerWidget'
import { TextBanner } from '../TextBanner/TextBanner'
import EdgeDrawerEmailWidget from '../../widgets/EdgeDrawerEmailWidget/EdgeDrawerEmailWidget'
import { useLayout } from '../../widgets/Layout'
import { configureView } from '../../utils/ViewConfiguration'

const PLPView: UI.ViewComponent<UI.LifeCycle> = observer(
  ({ onComponentDidMount }) => {
    const store = useDMEStore()
    const uiSettings = useLayout()
    const theme = useTheme()
    const layout = useLayout()
    const plpEmailCollectionEnabled = layout?.isPlpEmailCollectionEnabled
    const isSmallScreen = !useMediaQuery(theme.breakpoints.up('sm'))

    if (!store.insurance.present) {
      // There is a chance that we may link directly to the PLP with filter params
      HomeView.navigate({ search: window.location.search })
      return null
    }

    useEffect(() => {
      onComponentDidMount()
    }, [])

    function navigateToCustomerInformationView() {
      CustomerInformationView.navigate()
    }

    return (
      <>
        {uiSettings?.plpBannerText && (
          <TextBanner headingText={uiSettings.plpBannerText} />
        )}
        <PLPBannerWidget />
        <ProductListingWidget
          catalogId={store.insurance.catalogCategoryId || 'breast-pumps'}
          onAfterAddToCart={navigateToCustomerInformationView}
        />
        {plpEmailCollectionEnabled && isSmallScreen && (
          <EdgeDrawerEmailWidget />
        )}
      </>
    )
  }
)

export default configureView(PLPView)({ pathname: STORE_PATH })
